import { render, staticRenderFns } from "./peopleSample.vue?vue&type=template&id=e1e65916&scoped=true"
import script from "./peopleSample.vue?vue&type=script&lang=js"
export * from "./peopleSample.vue?vue&type=script&lang=js"
import style0 from "./peopleSample.vue?vue&type=style&index=0&id=e1e65916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e65916",
  null
  
)

export default component.exports